import React, { FC, PropsWithChildren } from "react";

/**
 * LMS FAQ container component's props definitions.
 * @param {string} id - Identifier for container section.
 * @param {string} additionalClassName - CSS class for the container.
 */
interface LmsFaqContainer {
    additionalClassName?: string
    id: string
}

/**
 * This container is used to wrap the FAQ section for LMS (Learning Management System) FAQ.
 *
 */
export const LmsFaqContainer: FC<PropsWithChildren<LmsFaqContainer>> = ({ children, id, additionalClassName }) => {
    let className = 'py-4 sm:py-8 bg-white'

    className += ` ${additionalClassName ?? ""}`;
    return (
        <section id={id} className={className}>
            {children}
        </section>
    )
}